let hasWebGlValue: boolean | undefined;

export default function hasWebGL(): boolean { 
	if (hasWebGlValue === undefined) {
		var canvas, ctx;
		try {
			canvas = document.createElement('canvas');
			ctx = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
		} catch (e) {}
		if (ctx && ctx instanceof WebGLRenderingContext) {
			hasWebGlValue = true
		} else {
			hasWebGlValue = false
		}
	}
	return hasWebGlValue;
}